import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import { AddMultipleInput } from './types';
import {
  thunkErrorHandlerWithoutSdk,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';

export const getFollowings: ApiMethod<void, string[], any> = async (
  _,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Followings_Client(
      undefined,
      contentClient
    );

    const response = await client.followings_ids_get_V1();
    if (response.success && response.data) {
      localStorage.setItem('followings', JSON.stringify(response.data));
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};
export const addContentToFollowings: ApiMethod<
  Server.UnFollowContentEntityInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Followings_Client(
      undefined,
      contentClient
    );

    const response = await client.followings_add_post_V1(data);
    if (response.success) {
      dispatch(
        CommonActions.setAlert({
          type: AlertType.SUCCESS,
          messages: [{ message: 'تمت الاضافة للمفضلة', code: 200, field: '' }],
        })
      );
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const removeContentToFollowings: ApiMethod<
  Server.FollowContentEntityInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Followings_Client(
      undefined,
      contentClient
    );

    const response = await client.followings_remove_post_V1(data);
    if (response.success) {
      dispatch(
        CommonActions.setAlert({
          type: AlertType.SUCCESS,
          messages: [{ message: 'تم الحذف من المفضلة', code: 200, field: '' }],
        })
      );
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const addMultiple: ApiMethod<AddMultipleInput, void, void> = async (
  body,
  { dispatch, rejectWithValue }
) => {
  return thunkErrorHandlerWithoutSdk(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Followings_Client(
          undefined,
          contentClient
        );

        return client.followings_addMultiple_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
